/**
 * ES2023+ polyfills for Chrome 109 (Windows 7 support)
 * Chrome 109 lacks "change array by copy" methods added in Chrome 110+
 */
import 'core-js/actual/array/to-sorted';
import 'core-js/actual/array/to-reversed';
import 'core-js/actual/array/to-spliced';
import 'core-js/actual/array/with';

// 1. Polyfill 'global' (Required by AWS SDK v2/v3 in Amplify v5)
(window as any).global = window;

// 2. Polyfill 'process' (Clean version - tiny, keep synchronous)
(window as any).process = {
  env: { DEBUG: undefined },
  browser: true,
  version: '',
  versions: { node: false }
};

// 3. Buffer polyfill - loaded on demand to reduce initial bundle
// AWS Amplify v6 uses Buffer for auth/crypto operations
// This defers the ~50KB buffer package from the critical rendering path
(window as any).Buffer = undefined;
(window as any).global.Buffer = undefined;

// Load Buffer asynchronously after idle
if (typeof requestIdleCallback === 'function') {
  requestIdleCallback(() => {
    import('buffer').then(({ Buffer }) => {
      (window as any).Buffer = Buffer;
      (window as any).global.Buffer = Buffer;
    });
  }, { timeout: 2000 });
} else {
  setTimeout(() => {
    import('buffer').then(({ Buffer }) => {
      (window as any).Buffer = Buffer;
      (window as any).global.Buffer = Buffer;
    });
  }, 1000);
}